import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingReportNoteView } from '@euler/model/coaching-practice';
import { memo } from 'react';
import { aiColors } from '../../../../ai-suite/theme';
import { ReportSection } from './ReportSection';

/** One column of notes under its colored title. */
export const NotesCard = memo(
  ({
    title,
    notes,
    color,
  }: {
    title: string;
    notes: CoachingReportNoteView[];
    color: string;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <ReportSection style={{ flex: 1, padding: rpx(14), gap: rpx(6) }}>
        <Typography.Text size={rpx(12)} bold color={color}>
          {title}
        </Typography.Text>
        {notes.map(x => (
          <Typography.Text
            key={`${x.turn}-${x.text}`}
            size={rpx(12)}
            color={aiColors.mutedForeground}
            style={{ lineHeight: rpx(18) }}
          >
            {x.text}
          </Typography.Text>
        ))}
      </ReportSection>
    );
  },
);
